import './recorder.js'
import './result.js'
import './wrp.js'

// グローバルに登録された各ライブラリをエクスポート
export const Recorder = window.Recorder
export const Result = window.Result
export const Wrp = window.Wrp

// WebSocket通信設定（元のプロジェクトから移植）
export const wrpConfig = {
  // === 音声認識設定 ===
  // grammarFileNames: '-a-general',     // 音声認識文法ファイル（一般用、医療用: '-a-medical'）→ DBのengineから取得
  // profileId: "",                      // プロファイルID（辞書登録用識別子）→ DBのprofileから取得
  profileWords: "",                      // プロファイル単語（認識精度向上のための追加単語辞書）
  segmenterProperties: "useDiarizer=1",  // セグメンタプロパティ文字列（話者分離機能を有効化）
  keepFillerToken: "",                   // フィラー単語を保持するかどうか（「えー」「あの」等の間投詞の扱い）
  resultUpdatedInterval: "",             // 認識中イベント発行間隔（単位：ミリ秒、リアルタイム更新頻度）
  extension: "",                         // 拡張情報（AmiVoice独自の追加パラメータ）
  codec: "",                            // 音声データ形式（自動設定、MSB16K等）
  resultType: "",                       // 認識結果タイプ（結果の形式指定）
  checkIntervalTime: 0,                 // 無発話許容時間（単位：ミリ秒、無音でタイムアウトする時間）
}

// Recorder設定値（元のプロジェクトから移植）
export const recorderConfig = {
  sampleRate: 16000,          // 録音サンプリング周波数（Hz、音質に影響）
  maxRecordingTime: 1200000,  // 連続録音可能時間（単位：ミリ秒、20分）
  downSampling: true,         // ダウンサンプリング（帯域圧縮でデータ量削減）wrp.jsの設定に合わせる
  adpcmPacking: false,        // ADPCM圧縮（音声データの圧縮方式）
}

